import * as React from 'react';
import { Link } from 'react-router-dom';
import { UitkSelect } from 'uitk-react-select';
import { UitkSpacing } from 'uitk-react-spacing';

export interface FlightsChildComponentProps {
  childNum: any;
  onChildAgeChange(event: any): any;
}

export class ChildAgeComponent extends React.Component<FlightsChildComponentProps, any> {
  public constructor(props) {
    super(props);
  }

  public renderAgeDropDown() {
    const childAge = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
    const childAgeDropDown = childAge.map((age) => {
      return (
        <option key={age} value={age}>
          {age}
        </option>
      );
    });

    return childAgeDropDown;
  }

  public render() {
    const { onChildAgeChange, childNum } = this.props;

    return (
      <>
        <UitkSpacing  margin={{ blockstart: 'four' }}>
          <UitkSelect
            id={`childAge${childNum}`}
            icon="person"
            label={`Child Age ${childNum}`}
            onChange={onChildAgeChange}
          >
            {this.renderAgeDropDown()}
          </UitkSelect>
        </UitkSpacing>
      </>
    );
  }
}
